import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade + rise wrapper.
export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Staggered container for grids.
export const Stagger = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: 0.12, delayChildren: delay } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y: 28 },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
    }}
  >
    {children}
  </motion.div>
);

// Small uppercase section label with gold tick.
export const Overline = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="h-px w-8 bg-gold" />
    <span className={`text-xs sm:text-sm uppercase tracking-[0.25em] font-medium ${dark ? "text-navy/60" : "text-gold"}`}>
      {children}
    </span>
  </div>
);
